import React, { useEffect, useState } from "react";
import { ButtonComponent, DatePickerComponent, InputField, PercentageInputBox, PriceInputBox, SelectBox, TimeDuration } from "../component/Common";
import { addRemoveType, cardType, countArray, daysArray, emiType, loanTypeList, monthsArray, paymentStatusForMortgage, paymentStatusForProperty, propertyTypes, yearsArray, yesNoArray } from "../constants/form_constatnts";
import withReactContent from 'sweetalert2-react-content'
import api from "../utils/api";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import { validateDates } from "../utils/validate";

const EmiDetails = ({ onNextPage, onPriviousPage }) => {
    const navigate = useNavigate();
    const MySwal = withReactContent(Swal);
    const [emiData, setemiData] = useState({
        //emi type
        expenseType: '',
        currentMortgageStatus: '',
        otherPropertyStatus: '',
        //card details
        cardDetails: [
            {
                cardHolderName: '',
                cardType: '',
                bankCompanyName: '',
                cardExpiryDate: '',
                cardBalance: '',
                cardLimit: '',
            }
        ],
        //loan details
        loanDetails: [
            {
                loanType: '',
                otherLoan: '',
                loanProviderName: '',
                loanAmount: '',
                loanBalance: '',
                monthlyLoanPayment: '',
                loanStartDate: '',
                loanEndDate: '',
            }
        ],
        //mortgage property details       
        currentMortgage: [
            {
                propertyType: '',
                mortgageLenderName: '',
                monthlyPayment: '',
                purchaseDate: '',
                originalAmount: '',
                mortgageDuration:
                {
                    years: '',
                    months: '',
                    days: '',
                },
                interestRate: '',
                amountLeft: '',
                propertyCurrentValue: '',
                mortgagePaymentType: '',
                arrearsCount: '',
                PropertyAddress: '',
            },
        ],

        //other property status        
        otherProperties: [
            {
                propertyType: '',
                lenderName: '',
                propertyPaymentType: '',
                purchaseDate: '',
                purchasePrice: '',
                propertyCurrentValue: '',
                outstandingBalance: '',
            }
        ],
        //main account details
        mainAccountName: '',
        AccountOpenDate: '',
        bankSortCode: '',
        accountNumber: '',
        bankAddress: '',
        newPaymentStatus: '',
    })

    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [errors, setErrors] = useState({});
    useEffect(() => {
        setIsInitialLoad(false);
    }, []);

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const applicationId = searchParams.get('applicationId');

    useEffect(() => {
        if (!isInitialLoad) {
            if (applicationId) {
                fetchEmiData(applicationId)
            }
        }
    }, [isInitialLoad]);

    const fetchEmiData = async (id) => {
        try {
            const result = await api.get(`/get-emi-details/${id}`);
            const data = result.data.EmiDetails;
            if (data) {
                const updateEmiData = {
                    expenseType: emiType.find(option => option.value === data.expenseType) || '',
                    currentMortgageStatus: yesNoArray.find(option => option.value === data.isCurrentMortgage) || '',
                    otherPropertyStatus: yesNoArray.find(option => option.value === data.isOtherProperty) || '',
                    mainAccountName: data.mainAccountName,
                    AccountOpenDate: data.AccountOpenDate,
                    bankSortCode: data.bankSortCode,
                    accountNumber: data.accountNumber,
                    bankAddress: data.bankAddress,
                    newPaymentStatus: yesNoArray.find(option => option.value === data.newPaymentStatus) || '',
                }
                if (data.expenseType === 'Credit Card' || data.expenseType === 'Both') {
                    updateEmiData.cardDetails = data.creditCardData.map(row => ({
                        id: row.id,
                        cardHolderName: row.cardHolderName,
                        cardType: cardType.find(option => option.value == row.cardType) || '',
                        bankCompanyName: row.bankCompanyName,
                        cardExpiryDate: row.cardExpiryDate,
                        cardBalance: row.cardBalance,
                        cardLimit: row.cardLimit,
                    }))
                }
                if (data.expenseType === 'Loan' || data.expenseType === 'Both') {
                    updateEmiData.loanDetails = data.loanData.map(row => ({
                        id: row.id,
                        loanType: loanTypeList.find(option => option.value == row.loanType) || '',
                        otherLoan: row.otherLoan,
                        loanProviderName: row.loanProviderName,
                        loanAmount: row.loanAmount,
                        loanBalance: row.loanBalance,
                        monthlyLoanPayment: row.monthlyLoanPayment,
                        loanStartDate: row.loanStartDate,
                        loanEndDate: row.loanEndDate,
                    }))
                }

                setemiData(prevData => ({
                    ...prevData,
                    ...updateEmiData,
                }));

                if (data.isCurrentMortgage == "Yes") {
                    setemiData(prevData => ({
                        ...prevData,
                        currentMortgage: data.mortgageData.map(row => ({
                            id: row.id,
                            propertyType: propertyTypes.find(option => option.value === row.propertyType) || '',
                            mortgageLenderName: row.mortgageLenderName,
                            monthlyPayment: row.monthlyPayment,
                            purchaseDate: row.purchaseDate,
                            originalAmount: row.originalAmount,
                            mortgageDuration:
                            {
                                years: yearsArray.find(option => option.value === `${row.years}`) || '',
                                months: monthsArray.find(option => option.value === `${row.months}`) || '',
                                days: daysArray.find(option => option.value === `${row.days}`) || '',
                            },
                            interestRate: row.interestRate,
                            amountLeft: row.amountLeft,
                            propertyCurrentValue: row.propertyCurrentValue,
                            mortgagePaymentType: paymentStatusForMortgage.find(option => option.value === row.mortgagePaymentType) || '',
                            arrearsCount: countArray.find(option => option.value === row.arrearsCount) || '',
                            PropertyAddress: row.PropertyAddress,
                        })),
                    }));
                }

                if (data.isOtherProperty == "Yes") {
                    setemiData(prevData => ({
                        ...prevData,
                        otherProperties: data.propertyData.map(row => ({
                            id: row.id,
                            propertyType: propertyTypes.find(option => option.value == row.propertyType) || '',
                            lenderName: row.lenderName,
                            propertyPaymentType: paymentStatusForProperty.find(option => option.value == row.propertyPaymentType) || '',
                            purchaseDate: row.purchaseDate,
                            purchasePrice: row.purchasePrice,
                            propertyCurrentValue: row.propertyCurrentValue,
                            outstandingBalance: row.outstandingBalance,
                        }))
                    }))
                }
            }
        } catch (error) {
            console.log("Error fetching emi details:", error);
        }
    }

    //handle error message
    useEffect(() => {
        for (const key in errors) {
            const errorMessageElement = document.getElementById(`error-message-${key}`);
            const dateErrorMessageElement = document.getElementById(`date-error-message-${key}`);
            const input = document.getElementById(`${key}`);
            if (errorMessageElement) {
                errorMessageElement.textContent = errors[key];
                if (input && input.tagName.toLowerCase() === 'input') {
                    if (errorMessageElement.textContent === '') {
                    } else {
                        input.style.setProperty('border', '1px solid red', 'important');
                    }
                }
            }

            if (dateErrorMessageElement) {
                dateErrorMessageElement.textContent = errors[key];
                if (input) {
                    const wrapper = input.getElementsByClassName('react-date-picker__wrapper')[0];
                    if (wrapper) {
                        if (dateErrorMessageElement.textContent === '') {
                            wrapper.style.setProperty('border', '1px solid gray', 'important');
                        } else {
                            wrapper.style.setProperty('border', '1px solid red', 'important');
                        }
                    }
                }
            }
        }
    }, [errors]);

    // Custom styles for react-select to handle error borders
    const customSelectStyles = (fieldName) => ({
        control: (provided) => ({
            ...provided,
            borderColor: errors[fieldName] ? 'red' : provided.borderColor,
            '&:hover': {
                borderColor: errors[fieldName] ? 'red' : provided['&:hover'].borderColor,
            },
        }),
    });

    //handle select box changes
    const handleOnChange = (value, name) => {
        setemiData((prevData) => ({ ...prevData, [name]: value }));
        setErrors((prevData) => ({ ...prevData, [name]: "" }));
    };

    //handle type selection of loan and card
    const handleTypeSelect = (index, value, name, type) => {
        var error = "";
        const newCard = type === addRemoveType.loan ? [...emiData.loanDetails] : type === addRemoveType.card ? [...emiData.cardDetails] : type === addRemoveType.otherProperty ? [...emiData.otherProperties] : [...emiData.currentMortgage];
        newCard[index] = {
            ...newCard[index],
            [name]: value
        };
        if (type === addRemoveType.loan) {

            setemiData((prevData) => {
                const updatedData = {
                    ...prevData,
                    loanDetails: prevData.loanDetails.map((detail, i) =>
                        i === index ? { ...detail, [name]: value } : detail
                    ),
                };
                if (name == 'loanStartDate' || name == 'loanEndDate') {
                    for (let index = 0; index < updatedData.loanDetails.length; index++) {
                        const element = updatedData.loanDetails[index];
                        const errorMessage = validateDates(element.loanStartDate, element.loanEndDate, `${name}${index}`);
                        console.log("Validation Result:", errorMessage);
                        error = errorMessage;
                    }
                }
                return updatedData;

            });



        } else if (type === addRemoveType.card) {
            setemiData((prevData) => ({
                ...prevData,
                cardDetails: prevData.cardDetails.map((detail, i) =>
                    i === index ? { ...detail, [name]: value } : detail
                ),
            }));
        } else if (type === addRemoveType.otherProperty) {
            setemiData((prevData) => ({
                ...prevData,
                otherProperties: prevData.otherProperties.map((detail, i) =>
                    i === index ? { ...detail, [name]: value } : detail
                ),
            }));
        } else if (type === addRemoveType.mortgage) {
            setemiData((prevData) => ({
                ...prevData,
                currentMortgage: prevData.currentMortgage.map((detail, i) =>
                    i === index ? { ...detail, [name]: value } : detail
                ),
            }));
        }
        setErrors((prevData) => ({ ...prevData, [name + index]: error }));
    }

    //handle time selection duration
    const handleTimeDurationChange = (index, value, unit) => {
        const updatedMortgage = emiData.currentMortgage.map((mortgage, mortgageIndex) => {
            if (mortgageIndex === index) {
                return {
                    ...mortgage,
                    mortgageDuration: {
                        ...mortgage.mortgageDuration,
                        [unit]: value
                    }
                };
            }
            return mortgage;
        });
        setemiData((prevData) => ({
            ...prevData,
            currentMortgage: updatedMortgage
        }));
    };


    //add and remove div - buttons
    const addRemoveButtons = (name1, name2, type) => {
        const shouldShowRemoveButton =
            (type === addRemoveType.card && emiData.cardDetails.length > 1) ||
            (type === addRemoveType.loan && emiData.loanDetails.length > 1) ||
            (type === addRemoveType.otherProperty && emiData.otherProperties.length > 1) ||
            (type === addRemoveType.mortgage && emiData.currentMortgage.length > 1);

        return (
            <div className="input-field-row">
                {shouldShowRemoveButton ? (
                    <button
                        className="removeDivButton"
                        onClick={() => removeDataDiv(type)}>
                        {name2}
                    </button>
                ) : (
                    <div className="removeDivButton"></div>
                )}
                <button
                    className="addDivButton"
                    onClick={() => addDataDiv(type)}>
                    {name1}
                </button>
            </div>
        );
    };


    //add card loan property and mortgage deatails div
    const addDataDiv = (type) => {
        if (type === addRemoveType.card) {
            validateCardDetails()
            setErrors(newErrors);
            if (isValid) {
                setemiData((prevData) => ({
                    ...prevData,
                    cardDetails: [
                        ...prevData.cardDetails,
                        {
                            cardHolderName: '',
                            cardType: '',
                            bankCompanyName: '',
                            cardExpiryDate: '',
                            creditBalance: '',
                            creditLimit: '',
                        }
                    ]
                }));
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Please fill above details first.",
                    iconColor: '#AB1717',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        } else if (type === addRemoveType.loan) {
            validateLoanDetails()
            setErrors(newErrors)
            if (isValid) {
                setemiData((prevData) => ({
                    ...prevData,
                    loanDetails: [
                        ...prevData.loanDetails,
                        {
                            loanType: '',
                            otherLoan: '',
                            loanProviderName: '',
                            loanAmount: '',
                            loanBalance: '',
                        }
                    ]
                }))
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Please fill above details first.",
                    iconColor: '#AB1717',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        } else if (type === addRemoveType.otherProperty) {
            validateOtherProperty()
            setErrors(newErrors)
            if (isValid) {
                setemiData((prevData) => ({
                    ...prevData,
                    otherProperties: [
                        ...prevData.otherProperties,
                        {
                            propertyType: '',
                            lenderName: '',
                            propertyCurrentValue: '',
                            purchaseDate: '',
                            purchasePrice: '',
                            outstandingBalance: '',
                            propertyPaymenttype: '',
                        }
                    ]
                }))
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Please fill above details first.",
                    iconColor: '#AB1717',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        } else if (type === addRemoveType.mortgage) {
            validateMortgageDetails()
            setErrors(newErrors)
            if (isValid) {
                setemiData((prevData) => ({
                    ...prevData,
                    currentMortgage: [
                        ...prevData.currentMortgage,
                        {
                            propertyType: '',
                            mortgageLenderName: '',
                            monthlyPayment: '',
                            purchaseDate: '',
                            originalAmount: '',
                            mortgageDuration:
                            {
                                years: '',
                                months: '',
                                days: '',
                            },
                            interestRate: '',
                            amountLeft: '',
                            propertyCurrentValue: '',
                            mortgagePaymenttype: '',
                            arrearsCount: '',
                            PropertyAddress: '',
                        }
                    ]
                }))
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Please fill above details first.",
                    iconColor: '#AB1717',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        }
    }

    //remove card details
    const removeDataDiv = (type) => {
        if (type === addRemoveType.card) {
            var nextCard = [...emiData.cardDetails];
            if (nextCard.length > 1) {
                nextCard = nextCard.slice(0, nextCard.length - 1);
                setemiData({ ...emiData, cardDetails: nextCard });
            }
        } else if (type === addRemoveType.loan) {
            var nextLoan = [...emiData.loanDetails];
            if (nextLoan.length > 1) {
                nextLoan = nextLoan.slice(0, nextLoan.length - 1);
                setemiData({ ...emiData, loanDetails: nextLoan });
            }
        } else if (type === addRemoveType.otherProperty) {
            var nextProperty = [...emiData.otherProperties];
            if (nextProperty.length > 1) {
                nextProperty = nextProperty.slice(0, nextProperty.length - 1);
                setemiData({ ...emiData, otherProperties: nextProperty });
            }
        } else if (type === addRemoveType.mortgage) {
            var nextMortgage = [...emiData.currentMortgage];
            if (nextMortgage.length > 1) {
                nextMortgage = nextMortgage.slice(0, nextMortgage.length - 1);
                setemiData({ ...emiData, currentMortgage: nextMortgage })
            }
        }
    }

    var isValid = true;
    const newErrors = {};
    let firstErrorFieldId = null;
    const setFieldError = (field, fieldName, errorMsg) => {
        if (!field) {
            isValid = false;
            newErrors[fieldName] = errorMsg;
            if (!firstErrorFieldId) firstErrorFieldId = fieldName;
        }
    };

    const validateCardDetails = () => {
        emiData.cardDetails.forEach((card, index) => {
            setFieldError(card.cardHolderName, `cardHolderName${index}`, "Name is required.");
            setFieldError(card.cardType, `cardType${index}`, "Card type is required.");
            setFieldError(card.bankCompanyName, `bankCompanyName${index}`, "Bank/Company name is required.");
            setFieldError(card.cardExpiryDate, `cardExpiryDate${index}`, "Card expiry date is required.");
            setFieldError(card.cardBalance, `cardBalance${index}`, "Card balance is required.");
            setFieldError(card.cardLimit, `cardLimit${index}`, "Card limit is required.");
        });
    }
    const validateLoanDetails = () => {
        emiData.loanDetails.forEach((loan, index) => {
            setFieldError(loan.loanType, `loanType${index}`, "Please select loan type.");
            setFieldError(loan.loanProviderName, `loanProviderName${index}`, "Loan Provider's name is required.");
            setFieldError(loan.loanAmount, `loanAmount${index}`, "Loan amount is required.");
            setFieldError(loan.loanBalance, `loanBalance${index}`, "Loan balance is required.");
            setFieldError(loan.monthlyLoanPayment, `monthlyLoanPayment${index}`, "Monthly payment amount info is required.");
            setFieldError(loan.loanStartDate, `loanStartDate${index}`, "Start date of loan is required.");
            setFieldError(loan.loanEndDate, `loanEndDate${index}`, "End date of loan is required.");
        });
    }

    const validateMortgageDetails = () => {
        emiData.currentMortgage.forEach((mortgage, index) => {
            setFieldError(mortgage.propertyType, `propertyType${index}`, "Please select property type.");
            setFieldError(mortgage.mortgageLenderName, `mortgageLenderName${index}`, "Lender's name is required.");
            setFieldError(mortgage.monthlyPayment, `monthlyPayment${index}`, "Monthly payment info is required.");
            setFieldError(mortgage.purchaseDate, `purchaseDate${index}`, "Purchase date is required.");
            setFieldError(mortgage.originalAmount, `originalAmount${index}`, "Original amount is required.");
            setFieldError(mortgage.mortgageDuration.years, `years${index}`, "Please select mortgage duration.");
            setFieldError(mortgage.mortgageDuration.months, `months${index}`, "Please select mortgage duration.");
            setFieldError(mortgage.mortgageDuration.days, `days${index}`, "Please select mortgage duration.");
            if (!mortgage.mortgageDuration.years || !mortgage.mortgageDuration.months || !mortgage.mortgageDuration.days) {
                setFieldError(false, `mortgageDuration${index}`, "Please select mortgage duration.");
            }
            setFieldError(mortgage.interestRate, `interestRate${index}`, "Mortgage interest rate is required.");
            setFieldError(mortgage.amountLeft, `amountLeft${index}`, "Mortgage left amount info is required.");
            setFieldError(mortgage.propertyCurrentValue, `propertyCurrentValue${index}`, "Property's current value is required.");
            setFieldError(mortgage.mortgagePaymentType, `mortgagePaymentType${index}`, "Please select payment option.");
            setFieldError(mortgage.arrearsCount, `arrearsCount${index}`, "Pease select Arrears count.");
            setFieldError(mortgage.PropertyAddress, `PropertyAddress${index}`, "Address is required.");

        });
    }

    const validateOtherProperty = () => {
        emiData.otherProperties.forEach((property, index) => {
            setFieldError(property.propertyType, `propertyType${index}`, "Please select property type.");
            setFieldError(property.lenderName, `lenderName${index}`, "Lender's name is required.");
            setFieldError(property.propertyPaymentType, `propertyPaymentType${index}`, "Please select property payment type.");
            setFieldError(property.purchaseDate, `purchaseDate${index}`, "Purchase date is required.");
            setFieldError(property.purchasePrice, `purchasePrice${index}`, "Purchase price is required.");
            setFieldError(property.propertyCurrentValue, `propertyCurrentValue${index}`, "Property current is required.");
            setFieldError(property.outstandingBalance, `outstandingBalance${index}`, "Outstanding balance is required.");
        });
    }

    const handleGoBack = () => {
        onPriviousPage()
    };

    const handleFormSubmission = async () => {
        setFieldError(emiData.expenseType, "expenseType", "Expense type is required.");
        if (emiData.expenseType.value === 'Credit Card') {
            validateCardDetails()
        }
        if (emiData.expenseType.value === 'Loan') {
            validateLoanDetails()
        }
        if (emiData.expenseType.value === 'Both') {
            validateCardDetails()
            validateLoanDetails()
        }
        setFieldError(emiData.currentMortgageStatus, "currentMortgageStatus", "Please select current mortgage status.");
        if (emiData.currentMortgageStatus.value === 'Yes') {
            validateMortgageDetails()
        }
        setFieldError(emiData.otherPropertyStatus, "otherPropertyStatus", "Please select other property status.");
        if (emiData.otherPropertyStatus.value === 'Yes') {
            validateOtherProperty()
        }

        setFieldError(emiData.mainAccountName, "mainAccountName", "Account name is required.");
        setFieldError(emiData.AccountOpenDate, "AccountOpenDate", "Account open date is required.");
        setFieldError(emiData.bankSortCode, "bankSortCode", "Bank sort code is required.");
        setFieldError(emiData.accountNumber, "accountNumber", "Account number is required.");
        setFieldError(emiData.bankAddress, "bankAddress", "Bank name is required.");
        setFieldError(emiData.newPaymentStatus, "newPaymentStatus", "payment status is required.");

        setErrors(newErrors);

        if (isValid) {
            try {
                const result = await api.post(`/emi-details/${applicationId}`, emiData);
                if (result.status == 200) {
                    Swal.fire({
                        icon: "success",
                        title: result.data.message,
                        iconColor: '#008000',
                        showConfirmButton: false,
                        timer: 2000
                    });
                    onNextPage();
                }
            } catch (error) {
                console.log("post api error in emi details form:", error);
            }
        } else {
            if (firstErrorFieldId) {
                const element = document.getElementById(firstErrorFieldId);
                if (element) {
                    element.scrollIntoView({ behavior: "smooth", block: "start" });
                    const yOffset = -120;
                    const yPosition = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: yPosition, behavior: "smooth" });
                    element.focus();
                }
            }
            return;
        }
    }

    ///save incomplete form
    const saveFormData = async () => {
        var isValid = true;
        let firstErrorFieldId = null;
        const errorObjects = document.getElementsByClassName('error_message');
        for (const element of Array.from(errorObjects)) {
            if (element.innerText !== "") {
                isValid = false;
                const result = element.id.split('-');
                firstErrorFieldId = result[result.length - 1];
                break;
            }
        };

        if (isValid) {
            try {
                const result = await api.post(`/emi-details/${applicationId}`, emiData);
                if (result.status === 200) {
                    Swal.fire({
                        icon: "success",
                        title: "Your details have been saved successfully",
                        iconColor: '#008000',
                        showConfirmButton: true,
                        showCancelButton: true,
                        confirmButtonText: 'Exit ',
                        confirmButtonColor: '#0E2F4F',
                        cancelButtonText: 'Stay on Page',
                    }).then(async (response) => {
                        if (response.isConfirmed) {
                            navigate('/mortgage_dashboard');
                            // try {
                            //     const logoutResult = await api.get('/logout');
                            //     if (logoutResult.status === 200) {
                            //         localStorage.removeItem('token');
                            //         window.location.href = 'https://mortgageapp.gargneha.com';
                            //     }
                            // } catch (logoutError) {
                            //     console.error("Logout API error:", logoutError);
                            // }
                        }
                    });
                }
            } catch (error) {
                console.log("Post API error:", error);
            }
        } else {
            if (firstErrorFieldId) {
                const element = document.getElementById(firstErrorFieldId);
                if (element) {
                    element.scrollIntoView({ behavior: "smooth", block: "start" });
                    const yOffset = -220;
                    const yPosition = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: yPosition, behavior: "smooth" });
                    element.focus();
                }
            }
            return;
        }
    };

    //add card details component
    const addCardDetails = () => {
        return (
            <>
                <p className="formHeading">Card Details</p>
                {emiData.cardDetails.map((card, index) => {
                    return <div key={index}>
                        {index > 0 && (<hr />)}
                        <p className="formHeading">{`${index + 1}. Card `}</p>
                        <InputField
                            label="Full Name on Card:"
                            value={card.cardHolderName}
                            htmlFor={`cardHolderName${index}`}
                            placeholder="Enter your full name on card"
                            type="text"
                            onChange={(e) => handleTypeSelect(index, e.target.value, "cardHolderName", addRemoveType.card)}
                        />
                        <SelectBox
                            label="Select Card Type:"
                            options={cardType}
                            htmlFor={`cardType${index}`}
                            value={card.cardType}
                            placeholder="Select card type"
                            onChange={(value) => handleTypeSelect(index, value, `cardType`, addRemoveType.card)}
                            styles={customSelectStyles(`cardType${index}`)}
                        />
                        <InputField
                            label="Bank/Company Name:"
                            value={card.bankCompanyName}
                            htmlFor={`bankCompanyName${index}`}
                            placeholder="Enter name of card provider Bank/Company"
                            onChange={(e) => handleTypeSelect(index, e.target.value, "bankCompanyName", addRemoveType.card)}
                        />
                        <DatePickerComponent
                            label="Expiry date of Card:"
                            htmlFor={`cardExpiryDate${index}`}
                            value={card.cardExpiryDate}
                            onChange={(value) => handleTypeSelect(index, value, `cardExpiryDate`, addRemoveType.card)}
                        />
                        <PriceInputBox
                            label="Outstanding Balance:"
                            htmlFor={`cardBalance${index}`}
                            value={card.cardBalance}
                            placeholder="Enter outstanding balance"
                            onChange={(e) => handleTypeSelect(index, e.target.value, 'cardBalance', addRemoveType.card)}
                        />
                        <PriceInputBox
                            label="Creadit Limit:"
                            htmlFor={`cardLimit${index}`}
                            value={card.cardLimit}
                            placeholder="Enter credit limit"
                            onChange={(e) => handleTypeSelect(index, e.target.value, "cardLimit", addRemoveType.card)}
                        />
                    </div>
                })}
            </>
        )
    }

    //add loan details component
    const addLoanDetails = () => {
        return (
            <>
                <p className="formHeading">Loan Details</p>
                {emiData.loanDetails.map((loan, index) => {
                    return <div key={index}>
                        {index > 0 && (<hr />)}
                        <p className="formHeading">{`${index + 1}. Loan `}</p>
                        <SelectBox
                            label="Select Loan Type:"
                            placeholder="Select loan type"
                            htmlFor={`loanType${index}`}
                            options={loanTypeList}
                            value={loan.loanType}
                            onChange={(value) => handleTypeSelect(index, value, 'loanType', addRemoveType.loan)}
                            styles={customSelectStyles(`loanType${index}`)}
                        />
                        {loan.loanType && loan.loanType.value === 'Other' && (
                            <InputField
                                label="Please Sepicify Loan Type:"
                                value={loan.otherLoan}
                                htmlFor={`otherLoan${index}`}
                                placeholder="Enter loan type"
                                onChange={(e) => handleTypeSelect(index, e.target.value, 'otherLoan', addRemoveType.loan)}
                            />
                        )}
                        <InputField
                            label="Loan Provider (Name of Bank or Financial Institution)"
                            value={loan.loanProviderName}
                            htmlFor={`loanProviderName${index}`}
                            type="text"
                            placeholder="Enter name of card provider Bank/Company"
                            onChange={(e) => handleTypeSelect(index, e.target.value, 'loanProviderName', addRemoveType.loan)}
                        />
                        <PriceInputBox
                            label="Loan Amount (Initial loan amount):"
                            htmlFor={`loanAmount${index}`}
                            value={loan.loanAmount}
                            placeholder="Enter loan amount"
                            onChange={(e) => handleTypeSelect(index, e.target.value, 'loanAmount', addRemoveType.loan)}
                        />
                        <PriceInputBox
                            label="Outstanding Balance (Remaining loan amount):"
                            htmlFor={`loanBalance${index}`}
                            value={loan.loanBalance}
                            placeholder="Enter outstanding balance"
                            onChange={(e) => handleTypeSelect(index, e.target.value, 'loanBalance', addRemoveType.loan)}
                        />
                        <PriceInputBox
                            label="Monthly Repayment (Amount you pay each month):"
                            htmlFor={`monthlyLoanPayment${index}`}
                            value={loan.monthlyLoanPayment}
                            placeholder="Enter monthly repayment amount"
                            onChange={(e) => handleTypeSelect(index, e.target.value, 'monthlyLoanPayment', addRemoveType.loan)}
                        />
                        <DatePickerComponent
                            label="Start Date of Loan:"
                            htmlFor={`loanStartDate${index}`}
                            value={loan.loanStartDate}
                            onChange={(value) => handleTypeSelect(index, value, 'loanStartDate', addRemoveType.loan)}
                        />
                        <DatePickerComponent
                            label="End Date of Loan:"
                            htmlFor={`loanEndDate${index}`}
                            value={loan.loanEndDate}
                            onChange={(value) => handleTypeSelect(index, value, 'loanEndDate', addRemoveType.loan)}
                        />
                    </div>
                })}
            </>
        )
    }

    const addOtherPropertyDetails = () => {
        return (
            <>
                {emiData.otherProperties.map((property, index) => {
                    return <div key={index}>
                        {index > 0 && (<hr />)}
                        <p className="formHeading">{`${index + 1}. Property `}</p>
                        <SelectBox
                            label="Select Property Type:"
                            options={propertyTypes}
                            htmlFor={`propertyType${index}`}
                            placeholder="Select property type"
                            value={property.propertyType}
                            onChange={(value) => handleTypeSelect(index, value, 'propertyType', addRemoveType.otherProperty)}
                            styles={customSelectStyles(`propertyType${index}`)}
                        />
                        <InputField
                            label="Lender's Name (any bank or company name):"
                            htmlFor={`lenderName${index}`}
                            value={property.lenderName}
                            placeholder="Enter lender's name (any bank or company name)"
                            onChange={(e) => handleTypeSelect(index, e.target.value, 'lenderName', addRemoveType.otherProperty)}
                        />
                        <SelectBox
                            label="Mortgage / Rent Payment:"
                            htmlFor={`propertyPaymentType${index}`}
                            options={paymentStatusForProperty}
                            value={property.propertyPaymentType}
                            placeholder="Select mortgage payment type"
                            onChange={(value) => handleTypeSelect(index, value, 'propertyPaymentType', addRemoveType.otherProperty)}
                            styles={customSelectStyles(`propertyPaymentType${index}`)}
                        />
                        <DatePickerComponent
                            label="Purchase Date:"
                            htmlFor={`purchaseDate${index}`}
                            value={property.purchaseDate}
                            onChange={(value) => handleTypeSelect(index, value, 'purchaseDate', addRemoveType.otherProperty)}
                        />
                        <PriceInputBox
                            label="Price at Purchase:"
                            htmlFor={`purchasePrice${index}`}
                            value={property.purchasePrice}
                            placeholder="Enter purchase price of property"
                            onChange={(e) => handleTypeSelect(index, e.target.value, 'purchasePrice', addRemoveType.otherProperty)}
                        />
                        <PriceInputBox
                            label="Estimated Current Value of property:"
                            htmlFor={`propertyCurrentValue${index}`}
                            value={property.propertyCurrentValue}
                            placeholder="Enter estimated current value of property"
                            onChange={(e) => handleTypeSelect(index, e.target.value, 'propertyCurrentValue', addRemoveType.otherProperty)}
                        />
                        <PriceInputBox
                            label="Outstanding Balance:"
                            htmlFor={`outstandingBalance${index}`}
                            value={property.outstandingBalance}
                            placeholder="Enter outstanding balance"
                            onChange={(e) => handleTypeSelect(index, e.target.value, 'outstandingBalance', addRemoveType.otherProperty)}
                        />
                    </div>
                })}
            </>
        )
    }

    const addCurrentMortgage = () => {
        return (
            <>
                {emiData.currentMortgage.map((mortgageProperty, index) => {
                    return <div key={index}>
                        {index > 0 && (<hr />)}
                        <p className="formHeading">{`${index + 1}. Current Mortgage `}</p>
                        <SelectBox
                            label="Select Property Type:"
                            options={propertyTypes}
                            htmlFor={`propertyType${index}`}
                            placeholder="Select property type"
                            value={mortgageProperty.propertyType}
                            onChange={(value) => handleTypeSelect(index, value, 'propertyType', addRemoveType.mortgage)}
                            styles={customSelectStyles(`propertyType${index}`)}
                        />
                        <InputField
                            label="Lender's Name (any bank or company name):"
                            htmlFor={`mortgageLenderName${index}`}
                            value={mortgageProperty.mortgageLenderName}
                            placeholder="Enter lender's name (any bank or company name)"
                            onChange={(e) => handleTypeSelect(index, e.target.value, 'mortgageLenderName', addRemoveType.mortgage)}
                        />
                        <PriceInputBox
                            label="Monthly Payment (Mortgage or Rent):"
                            htmlFor={`monthlyPayment${index}`}
                            value={mortgageProperty.monthlyPayment}
                            placeholder="Enter monthly payment"
                            onChange={(e) => handleTypeSelect(index, e.target.value, 'monthlyPayment', addRemoveType.mortgage)}
                        />
                        <DatePickerComponent
                            label="Purchase Date:"
                            htmlFor={`purchaseDate${index}`}
                            value={mortgageProperty.purchaseDate}
                            onChange={(value) => handleTypeSelect(index, value, 'purchaseDate', addRemoveType.mortgage)}
                        />
                        <PriceInputBox
                            label="Original Mortgage Amount:"
                            htmlFor={`originalAmount${index}`}
                            value={mortgageProperty.originalAmount}
                            placeholder="Enter original mortgage amount"
                            onChange={(e) => handleTypeSelect(index, e.target.value, 'originalAmount', addRemoveType.mortgage)}
                        />
                        <TimeDuration
                            label="Mortgage Term Remaining: "
                            htmlFor={`mortgageDuration${index}`}
                            fields={[
                                { name: 'years', value: mortgageProperty.mortgageDuration.years, options: yearsArray, style: customSelectStyles(`years${index}`) },
                                { name: 'months', value: mortgageProperty.mortgageDuration.months, options: monthsArray, style: customSelectStyles(`months${index}`) },
                                { name: 'days', value: mortgageProperty.mortgageDuration.days, options: daysArray, style: customSelectStyles(`days${index}`) }
                            ]}
                            onChange={(value, unit) => handleTimeDurationChange(index, value, unit)}
                        />
                        <PercentageInputBox
                            label="Mortgage Interest Rate:"
                            htmlFor={`interestRate${index}`}
                            value={mortgageProperty.interestRate}
                            placeholder="Enter mortgage interest rate"
                            onChange={(e) => handleTypeSelect(index, e.target.value, 'interestRate', addRemoveType.mortgage)}
                        />
                        <PriceInputBox
                            label="Mortgage Amount Left:"
                            htmlFor={`amountLeft${index}`}
                            value={mortgageProperty.amountLeft}
                            placeholder="Enter mortgage amount left"
                            onChange={(e) => handleTypeSelect(index, e.target.value, 'amountLeft', addRemoveType.mortgage)}
                        />
                        <PriceInputBox
                            label="Current Value of property:"
                            htmlFor={`propertyCurrentValue${index}`}
                            value={mortgageProperty.propertyCurrentValue}
                            placeholder="Enter current value of property"
                            onChange={(e) => handleTypeSelect(index, e.target.value, 'propertyCurrentValue', addRemoveType.mortgage)}
                        />
                        <SelectBox
                            label="Repayment / Interest only:"
                            htmlFor={`mortgagePaymentType${index}`}
                            options={paymentStatusForMortgage}
                            value={mortgageProperty.mortgagePaymentType}
                            placeholder="Select mortgage payment type"
                            onChange={(value) => handleTypeSelect(index, value, 'mortgagePaymentType', addRemoveType.mortgage)}
                            styles={customSelectStyles(`mortgagePaymentType${index}`)}
                        />
                        <SelectBox
                            label="Arrears in last 12 months:"
                            htmlFor={`arrearsCount${index}`}
                            options={countArray}
                            value={mortgageProperty.arrearsCount}
                            placeholder='Select number of times you missed mortgage payment'
                            onChange={(value) => handleTypeSelect(index, value, 'arrearsCount', addRemoveType.mortgage)}
                            styles={customSelectStyles(`arrearsCount${index}`)}
                        />
                        <InputField
                            label="Address:"
                            htmlFor={`PropertyAddress${index}`}
                            type="address"
                            value={mortgageProperty.PropertyAddress}
                            placeholder="Enter address"
                            onChange={(e) => handleTypeSelect(index, e.target.value, 'PropertyAddress', addRemoveType.mortgage)}
                        />
                    </div>
                })}
            </>
        )
    }

    return (
        <>
            <div className="personal-details-form">
                <div className="form_name">Credit Card And Loan Details
                    <p>All fields are required to submit the application
                        <span className="required">*</span>
                    </p>
                </div>
                <SelectBox
                    label="Expense Type:"
                    htmlFor='expenseType'
                    options={emiType}
                    value={emiData.expenseType}
                    placeholder="Select expense type"
                    onChange={(value) => handleOnChange(value, 'expenseType')}
                    styles={customSelectStyles('expenseType')}
                />
                {emiData.expenseType && emiData.expenseType.value === 'Credit Card' && (
                    <>
                        <hr />
                        {addCardDetails()}
                        {addRemoveButtons('Add another Card', 'Remove Card', addRemoveType.card)}
                    </>
                )}

                {emiData.expenseType && emiData.expenseType.value === 'Loan' && (
                    <>
                        <hr />
                        {addLoanDetails()}
                        {addRemoveButtons('Add another Loan Details', 'Remove Loan details', addRemoveType.loan)}
                    </>
                )}
                {emiData.expenseType && emiData.expenseType.value === 'Both' && (
                    <>
                        <hr />
                        {addCardDetails()}
                        {addRemoveButtons('Add another Card', 'Remove Card', addRemoveType.card)}
                        <hr />
                        {addLoanDetails()}
                        {addRemoveButtons('Add another Loan Details', 'Remove Loan details', addRemoveType.loan)}
                    </>
                )}

                <hr />
                <p className="formHeading">Current Mortgage Details</p>
                <SelectBox
                    label="Current Mortgage:"
                    options={yesNoArray}
                    htmlFor="currentMortgageStatus"
                    value={emiData.currentMortgageStatus}
                    placeholder="Do you have any current mortgage?"
                    onChange={(value) => handleOnChange(value, 'currentMortgageStatus')}
                    styles={customSelectStyles('currentMortgageStatus')}
                />
                {emiData.currentMortgageStatus && emiData.currentMortgageStatus.value === 'Yes' && (
                    <>
                        {addCurrentMortgage()}
                        {addRemoveButtons('Add More Current Mortgage', 'Remove Current Mortgage', addRemoveType.mortgage)}
                    </>
                )}
                <hr />
                <p className="formHeading">Other Property Details</p>
                <SelectBox
                    label="Do You Own Any other Property:"
                    options={yesNoArray}
                    htmlFor="otherPropertyStatus"
                    placeholder="Select if you have any other property"
                    value={emiData.otherPropertyStatus}
                    onChange={(value) => handleOnChange(value, 'otherPropertyStatus')}
                    styles={customSelectStyles('otherPropertyStatus')}
                />
                {emiData.otherPropertyStatus && emiData.otherPropertyStatus.value === 'Yes' && (
                    <>
                        {addOtherPropertyDetails()}
                        {addRemoveButtons('Add More Properties', 'Remove Property', addRemoveType.otherProperty)}
                    </>
                )}

                <hr />
                <p className="formHeading">Main Bank Account Details</p>
                <InputField
                    label="Main Bank Account Name:"
                    placeholder="Enter main bank account name"
                    value={emiData.mainAccountName}
                    htmlFor="mainAccountName"
                    onChange={(event) => handleOnChange(event.target.value, event.target.id)}
                />
                <DatePickerComponent
                    label="Date Bank Account Opened?"
                    htmlFor="AccountOpenDate"
                    value={emiData.AccountOpenDate}
                    onChange={(value) => handleOnChange(value, "AccountOpenDate")}
                />
                <InputField
                    label="Bank sort Code:"
                    placeholder="Enter bank sort code"
                    value={emiData.bankSortCode}
                    htmlFor="bankSortCode"
                    onChange={(event) => handleOnChange(event.target.value, event.target.id)}
                />
                <InputField
                    label="Bank account number:"
                    htmlFor="accountNumber"
                    value={emiData.accountNumber}
                    type="accountNumber"
                    placeholder="Enter bank account number"
                    onChange={(event) => handleOnChange(event.target.value, event.target.id)}
                />
                <InputField
                    label="Bank Address:"
                    placeholder="Enter bank address"
                    value={emiData.bankAddress}
                    htmlFor="bankAddress"
                    onChange={(event) => handleOnChange(event.target.value, event.target.id)}
                />
                <SelectBox
                    label="Use this Account for New Finance Payments:"
                    options={yesNoArray}
                    value={emiData.newPaymentStatus}
                    htmlFor='newPaymentStatus'
                    placeholder="Select an option"
                    onChange={(value) => handleOnChange(value, 'newPaymentStatus')}
                    styles={customSelectStyles('newPaymentStatus')}
                />
                <div className="buttons-style">
                    <div className="back-btn"><ButtonComponent name="Back" onClick={handleGoBack} /></div>
                    <div className="button-div">
                        <ButtonComponent name='Save & Exit' onClick={saveFormData} />
                        <ButtonComponent label="Submit" name='Continue' onClick={handleFormSubmission} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default EmiDetails;